import { Change, Distance, SurfaceChanges } from "@tvg/ts-types/Race";

export interface ChangesProcessed extends Change {
  keyword: string;
}

export const processSurfaceRaceChanges = (
  surface: SurfaceChanges | undefined
): ChangesProcessed[] => [
  ...getArrayValues(surface?.course || [], "Course"),
  ...getArrayValues(surface?.tempRailDistance || [], "Temp Rail Distance"),
  ...getArrayValues(surface?.condition || [], "Track Condition"),
  ...getDistanceArray(surface?.distance || [])
];

const getArrayValues = (
  changesArray: Change[],
  keyword: string
): ChangesProcessed[] =>
  changesArray && changesArray.length
    ? changesArray.map((change) => ({
        keyword,
        oldValue: change.oldValue,
        newValue: change.newValue,
        date: change.date
      }))
    : [];

const getDistanceArray = (changesArray: Distance[]): ChangesProcessed[] =>
  changesArray && changesArray.length
    ? changesArray.map((change) => ({
        keyword: "Distance",
        oldValue: `${
          change.oldValue.value
        }${change.oldValue.code.toLowerCase()}`,
        newValue: `${
          change.newValue.value
        }${change.newValue.code.toLowerCase()}`,
        date: change.date
      }))
    : [];
